<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<form [formGroup]="appOrgInfoForm" class="organization-app-info">
	<mat-form-field subscriptSizing="dynamic">
		<mat-label>{{ appStrings.ORG_EDITOR_APPLICATION_NAME }}</mat-label>
		<input matInput formControlName="name" type="text" automationId="organizationName" />
	</mat-form-field>
	<mat-form-field subscriptSizing="dynamic">
		<mat-label>{{ appStrings.ORG_EDITOR_APPLICATION_DESCRIPTION }}</mat-label>
		<input matInput formControlName="description" type="text" automationId="organizationDescription" />
	</mat-form-field>
	<mat-form-field subscriptSizing="dynamic">
		<mat-label>{{ appStrings.ORG_EDITOR_MAIN_WEBSITE_ADDRESS }}</mat-label>
		<input matInput formControlName="url" type="text" automationId="organizationUrl" />
	</mat-form-field>
	<mat-form-field
		*ngIf="!isAdding"
		floatLabel="always"
		subscriptSizing="dynamic"
		class="client-id-form-field"
	>
		<mat-label>{{ appStrings.ORG_EDITOR_CLIENT_ID }}</mat-label>
		<input
			matInput
			formControlName="clientID"
			class="client-id-input-field"
			type="text"
			readonly
			automationId="organizationClientId"
		/>
	</mat-form-field>
</form>
<button
	mat-stroked-button
	*ngIf="!isAdding"
	color="primary"
	(click)="openSecretDialog()"
	automationId="generateSecretBtn"
>
	{{ appStrings.ORG_EDITOR_GENERATE_NEW_SECRET.toUpperCase() }}
</button>
